module.exports = __webpack_public_path__ + "static/media/twitter.e052633d.svg";